import React from 'react'
import { ViewerData } from './types'
import { EChart } from '../EChart'
import { buildDualAxisChartModel, buildDualAxisOption } from './DualAxis.utils'

const DualAxisComponent = (props: ViewerData) => {
  const data = props.data || new Map()
  const { category, dataset } = buildDualAxisChartModel(data)
  const option = buildDualAxisOption(category, dataset)

  return (
    <div style={{ width: '100%' }}>
      <EChart
        option={option}
        width='100%'
        height={320}
      />
    </div>
  )
}

const DualAxis = DualAxisComponent
export { DualAxis }
